import { createAction } from "redux-act";

export const ResourcesLoadAction = createAction("Resources Load");
export const ResourcesLoadSuccessAction = createAction("Resources Load - Success");
export const ResourcesLoadFailedAction = createAction("Resources Load - Failed");
